"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _textField = _interopRequireDefault(require("./text-field"));

var _utils = _interopRequireDefault(require("../utils"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RegExpField = /*#__PURE__*/function (_TextField) {
  (0, _inherits2.default)(RegExpField, _TextField);

  var _super = _createSuper(RegExpField);

  function RegExpField() {
    (0, _classCallCheck2.default)(this, RegExpField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(RegExpField, [{
    key: "set",
    value: function set(props) {
      var clonedProps = Object.assign({}, props); // Convert string to RegExp?

      if (clonedProps.value !== undefined && !(clonedProps.value instanceof RegExp)) {
        clonedProps.value = _utils.default.toRegExp(clonedProps.value);
      }

      (0, _get2.default)((0, _getPrototypeOf2.default)(RegExpField.prototype), "set", this).call(this, clonedProps);
    }
  }]);
  return RegExpField;
}(_textField.default);

exports.default = RegExpField;